import PropTypes from "prop-types";
import {Fragment, useState} from "react";
import {useTranslation} from "react-i18next";
import imgBancamiga from "../../../assets/images/modal-icons/bancamiga-icon.svg";
import imgBankPlaza from "../../../assets/images/modal-icons/banco-plaza-icon.png";
import imgBankVzla from "../../../assets/images/modal-icons/bdv-icon.png";
import {SecondaryButton} from "../../Button";
import styles from "../DepositMethods.module.css";
import BankBancamiga from "./BankBancamiga";
import BankPlaza from "./BankPlaza";
import BankVenezuela from "./BankVzla";

const BankOptions = ({prev}) => {
  const [bankSelected, setBankSelected] = useState("");
  const {t} = useTranslation();

  return (
    <div>
      {bankSelected === "" && (
        <h4 className={styles.deposit_option_instructions}>{t("depositInstructionsBankOptionsTitle")}</h4>
      )}
      {bankSelected === "" && (
        <Fragment>
          <div className={styles.bankOptionsGroup}>
            <div
              onClick={() => setBankSelected("PlazBank")}
              className={styles.bankOptionCard}
            >
              <img
                src={imgBankPlaza}
                alt="Banco Plaza"
              />
            </div>

            <div
              onClick={() => setBankSelected("VenezuelaBank")}
              className={styles.bankOptionCard}
            >
              <img
                src={imgBankVzla}
                alt="Banco de Venezuela"
              />
            </div>

            <div
              onClick={() => setBankSelected("BancamigaBank")}
              className={styles.bankOptionCard}
            >
              <img
                src={imgBancamiga}
                alt="Bancamiga"
              />
            </div>
          </div>
          {bankSelected === "" && (
            <div className={styles.bankBackRow}>
              <SecondaryButton onClick={prev}>{t("depositInstructionsBack")}</SecondaryButton>
            </div>
          )}
        </Fragment>
      )}
      {bankSelected === "VenezuelaBank" && <BankVenezuela onBack={prev} />}
      {bankSelected === "PlazBank" && <BankPlaza onBack={prev} />}
      {bankSelected === "BancamigaBank" && <BankBancamiga onBack={prev} />}
    </div>
  );
};

BankOptions.propTypes = {
  prev: PropTypes.func,
};

export default BankOptions;
